import _ from 'lodash';
import { Dropdown, Icon } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { Board } from '@vibe/icons';

const labelRenderer = ({ label, boardName }: { value: any; label: any; boardName: any }) => {
  return (
    <div>
      <div style={{ marginBottom: '4px' }}>
        <span>{label}</span>
      </div>
      <div>
        <Icon icon={Board} size={16} style={{ marginRight: '4px', transform: 'translate3d(0,3px,0)' }} />
        <small>{boardName}</small>
      </div>
    </div>
  );
};

type PortalPickerProps = {
  portals: any[];
  value?: string;
  isLoading?: boolean;
  onChange: (portalId: string) => void;
};

export function PortalPicker({ value, onChange, portals, isLoading }: PortalPickerProps) {
  const options = portals.map((portal) => ({
    value: portal.portalId,
    label: `${portal.portalName}`,
    boardName: `${portal?.board?.name}`,
  }));

  //const selectedOption = options.find((option) => option.value === value) || options[0];
  const selectedOption = options.find((option) => option.value === value);

  return (
    <Dropdown
      placeholder="Choose a portal"
      size="medium"
      clearable={false}
      searchable={false}
      loading={isLoading}
      value={dropdownValue(selectedOption)}
      options={options}
      onChange={(newSelectedOption: any) => {
        if (newSelectedOption) {
          onChange(newSelectedOption.value);
        }
      }}
      className="custom_dropdown_with_loader"
      optionRenderer={labelRenderer}
    />
  );
}
